// Registra la copia local de CONEM (src/service-worker.js) solo en el build de producción: con
// `npm start` no existe el archivo y además estorbaría al recargar en desarrollo.
//
// Cuando hay una versión nueva ya descargada, avisa a la app con el evento 'conem-sw-update'
// (lo escucha AppUpdateNotifier) en vez de recargar sola: el inspector puede estar a media
// captura en campo.

export const SW_UPDATE_EVENT = 'conem-sw-update';

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        const notify = () => window.dispatchEvent(new CustomEvent(SW_UPDATE_EVENT, { detail: registration }));
        if (registration.waiting && navigator.serviceWorker.controller) notify();
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            // Solo es "actualización" si ya había una versión controlando la página
            if (installing.state === 'installed' && navigator.serviceWorker.controller) notify();
          });
        });
        // Al volver a la pestaña con señal, revisar si hay versión nueva
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible' && navigator.onLine) registration.update().catch(() => {});
        });
      })
      .catch((error) => console.warn('No se pudo registrar la copia local de CONEM:', error));

    let reloading = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    });
  });
}

/** Activa la versión nueva que está esperando; la página se recarga sola al tomar el control. */
export function applyUpdate(registration) {
  if (registration?.waiting) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
  }
}

/** Quita la copia local instalada y sus cachés (modo sin señal apagado). */
export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {});
  if (window.caches) {
    caches.keys()
      .then((keys) => keys.filter((key) => key.startsWith('conem-')).forEach((key) => caches.delete(key)))
      .catch(() => {});
  }
}
